var _IndeterminateCheckBo, _CheckBoxIcon, _CheckBoxOutlineBlank;
var _excluded = ["aria-label", "checked", "classes", "className", "color", "data-testid", "defaultChecked", "disabled", "error", "indeterminate", "name", "onBlur", "onChange", "onClick", "onFocus", "readOnly", "size", "sx", "value"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { forwardRef, useState } from 'react';
import { any, arrayOf, bool, func, object, oneOf, oneOfType, string } from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import clsx from 'clsx';
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon, IndeterminateCheckBox as IndeterminateCheckBoxIcon } from 'mosaic-react-icons';
import { useControlled, useIsFocusVisible } from '@mui/material/utils';
import { materialUIColors } from "../internals/utils/materialUiHelpers";
import { getAfterFocusStyles } from "../internals/utils";
import checkboxClasses from "./sovosCheckboxClasses";
export var getBoxColors = function getBoxColors(_ref) {
  var checked = _ref.checked,
    color = _ref.color,
    disabled = _ref.disabled,
    error = _ref.error,
    indeterminate = _ref.indeterminate,
    palette = _ref.palette;
  var checkedColor;
  var uncheckedColor;
  if (error) {
    checkedColor = palette.error.main;
    uncheckedColor = palette.error.main;
  } else if (disabled) {
    checkedColor = palette.text.disabled;
    uncheckedColor = palette.text.disabled;
  } else {
    switch (color.toLowerCase()) {
      case materialUIColors.default:
        checkedColor = palette.text.secondary;
        break;
      case materialUIColors.primary:
        checkedColor = palette.primary.main;
        break;
      case materialUIColors.secondary:
        checkedColor = palette.secondary.main;
        break;
      default:
        checkedColor = color;
    }
    uncheckedColor = palette.text.secondary;
  }
  var boxColor = checked || indeterminate ? checkedColor : uncheckedColor;
  var calculateColor = function calculateColor(opacity) {
    return disabled ? 'transparent' : alpha(checkedColor, opacity);
  };
  var hoverColor = calculateColor(palette.action.hoverOpacity);
  var hoverFocusColor = calculateColor(palette.action.focusOpacity + palette.action.hoverOpacity);
  return {
    boxColor: boxColor,
    hoverColor: hoverColor,
    hoverFocusColor: hoverFocusColor
  };
};
var StyledSovosCheckbox = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'indeterminate' && prop !== 'color' && prop !== 'error' && prop !== 'size';
  }
})(function (_ref2) {
  var checked = _ref2.checked,
    color = _ref2.color,
    disabled = _ref2.disabled,
    error = _ref2.error,
    indeterminate = _ref2.indeterminate,
    size = _ref2.size,
    _ref2$theme = _ref2.theme,
    palette = _ref2$theme.palette,
    spacing = _ref2$theme.spacing,
    shape = _ref2$theme.shape;
  var _getBoxColors = getBoxColors({
      checked: checked,
      color: color,
      disabled: disabled,
      error: error,
      indeterminate: indeterminate,
      palette: palette
    }),
    boxColor = _getBoxColors.boxColor,
    hoverColor = _getBoxColors.hoverColor,
    hoverFocusColor = _getBoxColors.hoverFocusColor;
  var containerSize = function () {
    if (size === 'tiny') return spacing(3);
    if (size === 'small') return spacing(4);
    return spacing(5);
  }();
  var iconSize = function () {
    if (size === 'tiny') return spacing(1.75);
    if (size === 'small') return spacing(2.5);
    return spacing(3);
  }();
  return _defineProperty({
    alignItems: 'center',
    borderRadius: shape.borderRadiusRound,
    display: 'inline-flex',
    height: containerSize,
    justifyContent: 'center',
    position: 'relative',
    width: containerSize,
    '& svg': {
      color: boxColor,
      height: iconSize,
      width: iconSize
    },
    '&:hover': {
      backgroundColor: hoverColor
    }
  }, "&.".concat(checkboxClasses.focusVisible), _objectSpread(_objectSpread({}, getAfterFocusStyles({
    offset: 0
  })), {}, {
    '&:hover': {
      backgroundColor: hoverFocusColor
    }
  }));
});
var StyledInput = styled('input')(function () {
  return {
    cursor: 'pointer',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    '&:disabled': {
      cursor: 'default'
    }
  };
});
var SovosCheckbox = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var ariaLabel = _ref4['aria-label'],
    checkedProp = _ref4.checked,
    classes = _ref4.classes,
    className = _ref4.className,
    _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'primary' : _ref4$color,
    dataTestId = _ref4['data-testid'],
    defaultChecked = _ref4.defaultChecked,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    error = _ref4.error,
    _ref4$indeterminate = _ref4.indeterminate,
    indeterminate = _ref4$indeterminate === void 0 ? false : _ref4$indeterminate,
    name = _ref4.name,
    onBlur = _ref4.onBlur,
    onChange = _ref4.onChange,
    onClick = _ref4.onClick,
    onFocus = _ref4.onFocus,
    _ref4$readOnly = _ref4.readOnly,
    readOnly = _ref4$readOnly === void 0 ? false : _ref4$readOnly,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'medium' : _ref4$size,
    sx = _ref4.sx,
    value = _ref4.value,
    rest = _objectWithoutProperties(_ref4, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useControlled = useControlled({
      controlled: checkedProp,
      default: Boolean(defaultChecked),
      name: 'SovosCheckbox',
      state: 'checked'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    checked = _useControlled2[0],
    setCheckedState = _useControlled2[1];
  var _useIsFocusVisible = useIsFocusVisible(),
    isFocusVisibleRef = _useIsFocusVisible.isFocusVisibleRef,
    handleFocusVisible = _useIsFocusVisible.onFocus,
    handleBlurVisible = _useIsFocusVisible.onBlur;
  var handleOnBlur = function handleOnBlur(event) {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setIsFocused(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleOnFocus = function handleOnFocus(event) {
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setIsFocused(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleOnChange = function handleOnChange(event) {
    var newValue = event.target.checked;
    setCheckedState(newValue);
    if (onChange) {
      onChange(event, newValue);
    }
  };
  var Icon;
  if (indeterminate) {
    Icon = _IndeterminateCheckBo || (_IndeterminateCheckBo = /*#__PURE__*/React.createElement(IndeterminateCheckBoxIcon, {
      "data-testid": "indeterminate-icon"
    }));
  } else if (checked) {
    Icon = _CheckBoxIcon || (_CheckBoxIcon = /*#__PURE__*/React.createElement(CheckBoxIcon, {
      "data-testid": "checkbox-icon"
    }));
  } else {
    Icon = _CheckBoxOutlineBlank || (_CheckBoxOutlineBlank = /*#__PURE__*/React.createElement(CheckBoxOutlineBlankIcon, {
      "data-testid": "blankoutline-icon"
    }));
  }
  return /*#__PURE__*/React.createElement(StyledSovosCheckbox, {
    checked: checked,
    className: clsx('sovosCheckbox', classes === null || classes === void 0 ? void 0 : classes.root, className, _defineProperty({}, "".concat(checkboxClasses.focusVisible), isFocused)),
    color: color,
    "data-testid": dataTestId,
    disabled: disabled,
    error: error,
    indeterminate: indeterminate,
    size: size,
    sx: sx
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({
    "aria-label": ariaLabel,
    checked: checked,
    className: clsx('sovosCheckbox__input', classes === null || classes === void 0 ? void 0 : classes.input),
    disabled: disabled,
    name: name,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    onClick: onClick,
    onFocus: handleOnFocus,
    readOnly: readOnly,
    ref: ref,
    type: "checkbox",
    value: value
  }, rest)), Icon);
});
SovosCheckbox.propTypes = {
  /**
   * Label for screen readers
   */
  'aria-label': string,
  /**
   * If `true`, the input is checked
   */
  checked: bool,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Material UI theme color of the component
   */
  color: oneOf(['primary', 'default']),
  /**
   * @ignore
   */
  'data-testid': string,
  /**
   * If `true`, the input default is checked
   */
  defaultChecked: bool,
  /**
   * If `true`, the input is disabled
   */
  disabled: bool,
  /**
   * If `true`, the component will display an error state
   */
  error: bool,
  /**
   * If `true`, the input appears indeterminate
   */
  indeterminate: bool,
  /**
   * Name of the input
   */
  name: string,
  /**
   * Callback fired when the checkbox loses focus
   */
  onBlur: func,
  /**
   * Callback fired when input value is changed `function(event: object,
   * checked: bool) => void`
   */
  onChange: func,
  /**
   * Callback fired when the checkbox is clicked. Primarily used to stop
   * further propagation of the current event.
   */
  onClick: func,
  /**
   * Callback fired when the checkbox gets focus
   */
  onFocus: func,
  /**
   * @ignore
   * @deprecated -- remove for v12
   */
  readOnly: bool,
  /**
   * Size of the checkbox
   */
  size: oneOf(['tiny', 'small', 'medium']),
  /**
   * The system prop that allows defining system overrides as well as
   * additional CSS styles.
   */
  sx: oneOfType([arrayOf(oneOfType([func, object, bool])), func, object]),
  /**
   * Value of the input
   */
  value: any
};
SovosCheckbox.baseComponent = {
  name: 'Checkbox'
};
export default SovosCheckbox;